const portfolio = {
    display: `inline-flex`,
    borderRadius: `full`,
    textDecoration: `none`,
    fontWeight: `normal`,
    verticalAlign: `middle`,
    transition: ` all 250ms ease`,
    cursor: `pointer`,
    px: 3,
    py: 1,
    bg: `omegaLight`,
    color: `text`,
    ':hover': {
      bg: `alpha`,
      color: `white`
    }
}

export default portfolio